import React from 'react';
import { Grid, MenuItem, TextField, Typography } from '@mui/material';
import { ChangeHandler } from 'types/form';
import { Product } from 'types/product';

const UNITS = ['un', 'cx', 'par', 'pç', 'kit', 'fr', 'amp', 'ml', 'l', 'g', 'kg', 'm'];

interface ProductFormProps {
  product: Product;
  handleChange: ChangeHandler<Product>;
  validation: string;
}

const ProductForm: React.FC<ProductFormProps> = ({ product, handleChange, validation }) => {
  // produtos antigos podem ter uma unidade fora da lista; ela continua selecionável
  const units = product.unit && !UNITS.includes(product.unit) ? [product.unit, ...UNITS] : UNITS;

  return (
    <Grid container size={12} spacing={2} maxWidth={900}>
      <Grid size={12}>
        <Typography variant="subtitle2" fontWeight={700} color="primary">
          Dados do produto
        </Typography>
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          fullWidth
          autoFocus
          label="Nome"
          placeholder="Digite o nome do produto"
          value={product.name}
          onChange={e => handleChange('name', e.target.value)}
          error={validation === 'name'}
          helperText={validation === 'name' ? 'Nome é obrigatório' : ''}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 4 }}>
        <TextField
          fullWidth
          label="Fabricante"
          placeholder="Digite o nome do fabricante"
          value={product.manufacturer}
          onChange={e => handleChange('manufacturer', e.target.value)}
          error={validation === 'manufacturer'}
          helperText={validation === 'manufacturer' ? 'Fabricante é obrigatório' : ''}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 2 }}>
        <TextField
          select
          fullWidth
          label="Unidade"
          value={product.unit || 'un'}
          onChange={e => handleChange('unit', e.target.value)}
        >
          {units.map(unit => (
            <MenuItem key={unit} value={unit}>
              {unit}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  );
};

export default ProductForm;
